import axios from "axios";
import { NotificationManager } from "react-notifications";
import i18n from 'i18next';

export default ({
  bypassAuthCheck = false,
  baseURL = "/api",
  headers,
  ...props
} = {}) => {
  const config = {
    baseURL,
    headers,
    ...props,
  };
  const instance = axios.create(config);
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status===400) {
        if (error.response?.data?.code === "XeroNotFound"){
          NotificationManager.error(i18n.t("The resource you're looking for cannot be found on Xero"))
        }else{
          return Promise.reject(error);
        }
      } else {
        if (!error.response?.data?.code === "not_authenticated") {
          NotificationManager.error(error.response.data.detail)
        } else if (error.response?.data?.code === 'authentication_failed') { 
          NotificationManager.error(error.response.data.detail)
        } else {
          return Promise.reject(error);
        }
      }
      return error;
    }
  );

  return instance;
};
